<template>
    <div class="media-container">
        <div class="title d-md-none">Media</div>
        <media-tile-container></media-tile-container>
        <transition name="fade-chart" mode="out-in">
            <h1 class="max-container loading" v-if="refreshingCharts">Loading charts<span class="indicator">.</span><span class="indicator">.</span><span class="indicator">.</span></h1>
            <big-chart-container class="chart-container" v-if="!refreshingCharts && chartData.data"></big-chart-container>
        </transition>
        <!-- <transition name="fade">
            <h1 class="max-container loading" v-if="refreshingPacing">Loading table<span class="indicator">.</span><span class="indicator">.</span><span class="indicator">.</span></h1>
            <pacing-table v-if="!refreshingPacing && pacingData"></pacing-table>
        </transition> -->
    </div>
</template>

<script>
    import store from '@/store';

    import MediaTileContainer from '@/components/tiles/MediaTileContainer';
    import BigChartContainer from '@/components/BigChartContainer';
    import PacingTable from '@/components/PacingTable';

    export default {
        components: {
            MediaTileContainer,
            BigChartContainer,
            PacingTable,
        },
        computed: {
            chartData() {
                return store.state.chartData;
            },
            pacingData() {
                return store.state.pacingData.data;
            },
            refreshingCharts() {
                return store.state.refreshStatusCharts;
            },
            refreshingPacing() {
                return store.state.refreshStatusPacing;
            },
        },
    };
</script>

<style lang="scss" scoped>
    @import '../assets/scss/partials/variables';

    .chart-container {
        margin-bottom: 63px;

        @media screen and (min-width: $tablet) {
            margin-bottom: 50px;
        }
    }

    .title {
        margin-bottom: 25px;
        color: $kpmg-blue;
        font-size: 40px;
        text-align: center;
    }
</style>



// WEBPACK FOOTER //
// src/components/MediaContainer.vue